import React, { useState, useEffect } from 'react';
import Button from "react-bootstrap/Button";
import Container from 'react-bootstrap/Container';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { SignOutButton } from './office365auth/SignOutButton';

import { createAPIEndpoint} from '../api'
import { ENDPOINTS } from '../api/config'

import ErrorModal, { useErrorHandling } from './ErrorModal';
import Spinner from './Spinner';
import Plantilla from './plantillas/Plantilla'

/**
 * Renders Buscar component
 */

export default function Buscar(props) {
    const { error, clearError, showErrorModal } = useErrorHandling('PA002');
    const [showSpinner, setShowSpinner] = useState(false);

    function GetStudentInfo() {
        setShowSpinner(true);
        const mat = document.getElementById('matricula');

        if (!(mat && mat.value)) {
            alert('La matricula no puede estar vacía');
            setShowSpinner(false);
            return;
        }

        createAPIEndpoint(ENDPOINTS.getStudentData)
            .fetchById(mat.value)
            .then(res => {
                props.onUpdateStudentInfo(res.data);
            })
            .catch(err => {
                showErrorModal(err, error.serie, '');
            })
            .finally(() => {
                //setShowSpinner(false);
            });
    }

    return (
        <Container>
            <Spinner show={showSpinner} />

            <Row style={{ textAlign: "left" }}>
                <Col className="d-grid gap-2 m-2">
                    <Plantilla id="Buscar"></Plantilla>
                </Col>
            </Row>
            <Row style={{ textAlign: "left" }}>
                <Col className="d-grid gap-2 m-2">
                    <input type="text" id="matricula" width="100%"/>
                </Col>
            </Row>

            <Row style={{ textAlign: "left" }}>
                <Col className="d-grid gap-2 m-2">
                    <Button id="btnPost" type="button" className="btn btn-primary" onClick={() => GetStudentInfo()}>Generar formato</Button>
                    <SignOutButton></SignOutButton>
                </Col>
            </Row>

            <ErrorModal error={error} onClose={clearError} />
        </Container>
    );
}
